import webContextProvider from "../../../../../providers/webContextProvider";

export default () => webContextProvider().storeId;
